/*import DashboardIcon from '@mui/icons-material/Dashboard'
import PaymentIcon from '@mui/icons-material/Payment'
import AccountBoxIcon from '@mui/icons-material/AccountBox'
import { MenuItemInterface } from '../../types/customTypes'
import { Business, PeopleTwoTone } from '@mui/icons-material'

export const sidebarListItems: MenuItemInterface[] = [
  {
    text: ' Anasayfa ',
    icon: <DashboardIcon />,
    link: '/',
  },
  
]
export default sidebarListItems
*/

import PercentIcon from "@mui/icons-material/Percent";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { MenuItemInterface } from '../../types/customTypes'


export const sidebarListItems: MenuItemInterface[] = [
  {
    text: "ANASAYFA",
    icon: <DashboardIcon />,
    link: "/",
  },
  {
    text: "TEKLİFLER",
    icon: <PercentIcon />,
    link: "/manageOffer",
  },
  {
    text: "SEPET",
    icon: <ShoppingBasketIcon />,
    link: "/manageBasket",
  },
  {
    text: "FİNANS İSTEKLERİ",
    icon: <AccountBalanceIcon />,
    link: "/manageFinancingRequest",
  },
];

export default sidebarListItems;
